import React, { useCallback, useState } from "react";
import ReactDOM from "react-dom";
import { pdfjs, Document, Page } from "react-pdf";
import { useIntersectionObserver } from "@wojtekmaj/react-hooks";

//import "./styles.css";

import samplePDF from "./sample.pdf"

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const observerConfig = {
    // How much of the page needs to be visible to consider page visible
    threshold: 0.6,
    root: null,
    rootMargin: "0%",
};

function PageWithObserver({ pageNumber, setPageVisibility, ...otherProps }) {
    const [page, setPage] = useState();

    const onIntersectionChange = useCallback(
        ([entry]) => {
            setPageVisibility(pageNumber, entry.isIntersecting);
        },
        [pageNumber, setPageVisibility]
    );

    useIntersectionObserver(page, observerConfig, onIntersectionChange);

    return <Page canvasRef={setPage} pageNumber={pageNumber} {...otherProps} />;
}

function Test() {
    const [numPages, setNumPages] = useState(null);
    const [visiblePages, setVisiblePages] = useState({});

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    const setPageVisibility = useCallback((pageNumber, isIntersecting) => {
        setVisiblePages((prevVisiblePages) => ({
            ...prevVisiblePages,
            [pageNumber]: isIntersecting
        }));
    }, []);

    return (
        <>
            <Document file={samplePDF} onLoadSuccess={onDocumentLoadSuccess}>
                {Array.from(new Array(numPages), (el, index) => (
                    <PageWithObserver
                        key={`page_${index + 1}`}
                        pageNumber={index + 1}
                        setPageVisibility={setPageVisibility}
                    />
                ))}
            </Document>
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    background: "white",
                    padding: 10,
                    border: "1px thin"
                }}
            >
                Visible pages:{" "}
                {Object.entries(visiblePages)
                    .filter(([key, value]) => value)
                    .map(([key]) => key)
                    .join(", ") || "(none)"}
            </div>
        </>
    );
}

export default Test;
